import { useAssistantServices } from '../AssistantServices'

export function useAssistantBackend() {
  return useAssistantServices().backend
}
